import api from './api';

export const listHolidays = () => api.get('/holidays');
export const createHoliday = (data) => api.post('/holidays', data);
export const deleteHoliday = (id) => api.delete(`/holidays/${id}`);
export const upcomingHolidays = (days = 7) => api.get('/holidays/upcoming', { params: { days } });
export const upcomingHolidaysCached = (days = 7) => api.get('/holidays/upcoming-cached', { params: { days } });

export default { listHolidays, createHoliday, deleteHoliday, upcomingHolidays, upcomingHolidaysCached };
